import { buildDynamicFiltersQuery } from "../../charts/TableView/functions/dynamicDrillDown";
import ChartItem from "./ChartItem";

export default function DrilldownItem({ chart, executedCharts, theme }) {
  if (!chart.hasRowExpand) {
    return null;
  }

  return (
    <div style={{ marginLeft: 20 }}>
      <ChartItem
        chart={{ ...chart, ...chart.rowExpandVisualizationParams }}
        executedCharts={executedCharts}
        theme={theme}
      />
    </div>
  );
}

export function buildDrilldownInnerChart({
  visualizations,
  allLoaded,
  executedCharts,
  drilldownLoading,
}) {
  if (!allLoaded) {
    return [];
  }

  return visualizations.reduce((acc, curr) => {
    function check(chart) {
      const innerChart = {
        ...chart,
        ...chart.rowExpandVisualizationParams,
        ...(allLoaded && {
          filters: buildDynamicFiltersQuery(
            executedCharts[chart.visualizationId].data[0],
            chart.rowExpandVisualizationParams.dynamicFilters,
            chart.rowExpandVisualizationParams.dynamicFilterValue,
            chart.parameterizedFilterPrefix
          ),
        }),
      };

      acc.push(innerChart);

      if (
        innerChart.hasRowExpand &&
        executedCharts[innerChart.visualizationId] &&
        !drilldownLoading
      ) {
        check(innerChart);
      }
    }

    if (
      curr.hasRowExpand &&
      executedCharts[curr.visualizationId] &&
      !drilldownLoading
    ) {
      check(curr);
    }

    return acc;
  }, []);
}
